import { Box, HStack, Switch, Text, VStack, Badge } from '@chakra-ui/react';

// 機構功能開關清單。**超級管理員的「授予」與機構管理員的「啟用」共用這個元件**，
// 差別只在 mode，避免兩邊各寫一份而漸漸長歪（例如日後新增功能只改到其中一邊）。
//
// 兩層授權模型（見後端 app/core/institution_features.py）：
//   granted（超管）→ 這間機構「可以用」哪些
//   enabled（機構）→ 在被授予的範圍內「要不要開」
//   實際生效 = 兩層 AND
//
// mode="grant"  超管用：切換 granted。未授予者連帶讓機構端的開關失效，故標示清楚。
// mode="enable" 機構用：切換 enabled。**未獲授權的項目一律停用且標示「未授權」**——
//               不是隱藏，因為「看得到但不能開」才讓機構知道有這個功能可以去談，
//               隱藏會讓人以為系統沒有這個能力。
const FEATURES = [
    { key: 'pickup', label: '接送通知', desc: '家長端接送流程與到班通知' },
    { key: 'comm_book', label: '電子聯絡簿', desc: '每日聯絡簿與家長簽收' },
    { key: 'chat', label: '親師對話', desc: '老師與家長的即時訊息' },
    { key: 'announcements', label: '校園公告', desc: '公告發布與已讀統計' },
    { key: 'leaves', label: '請假登記', desc: '家長線上請假' },
    { key: 'lunch', label: '訂餐登記', desc: '午餐訂購與統計' },
    { key: 'makeup', label: '補課管理', desc: '補課安排與追蹤' },
    { key: 'car_plate', label: '車號登錄', desc: '家長登錄車號，接送時顯示' },
    { key: 'simple_pickup', label: '簡化接送', desc: '幼稚園模式：App 端不看狀態，直接通知' },
];

export default function InstitutionFeatureSwitches({ mode, granted = {}, enabled = {}, onChange, isDisabled }) {
    const isGrantMode = mode === 'grant';

    return (
        <VStack align="stretch" spacing={0}>
            {FEATURES.map(({ key, label, desc }, i) => {
                const isGranted = granted[key] !== false;          // 未指定＝沿用預設（授予）
                const checked = isGrantMode ? isGranted : (enabled[key] !== false && isGranted);
                // 機構模式下，沒被授予的項目不能開
                const locked = isDisabled || (!isGrantMode && !isGranted);

                return (
                    <HStack
                        key={key}
                        justify="space-between"
                        py={3}
                        borderTop={i === 0 ? 'none' : '1px solid'}
                        borderColor="neutral.200"
                        opacity={locked && !isGrantMode ? 0.55 : 1}
                    >
                        <Box>
                            <HStack spacing={2}>
                                <Text fontSize="sm" fontWeight="medium" color="neutral.800">{label}</Text>
                                {!isGrantMode && !isGranted && (
                                    <Badge colorScheme="gray" fontSize="10px">未授權</Badge>
                                )}
                            </HStack>
                            <Text fontSize="xs" color="neutral.500" mt={0.5}>{desc}</Text>
                        </Box>
                        <Switch
                            colorScheme="brand"
                            isChecked={checked}
                            isDisabled={locked}
                            onChange={(e) => onChange(key, e.target.checked)}
                        />
                    </HStack>
                );
            })}
        </VStack>
    );
}

export { FEATURES };
